import { type ProgramIncrementAttributes } from './generated/ProgramIncrementAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ProgramIncrement extends ProgramIncrementAttributes {}

@model
class ProgramIncrement extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProgramIncrement' = 'ProgramIncrement';
  get typename(): 'ProgramIncrement' {
    return 'ProgramIncrement';
  }

  static internalTypename: 'ProgramIncrement' = 'ProgramIncrement';
  get internalTypename(): 'ProgramIncrement' {
    return 'ProgramIncrement';
  }

  static terminologyName = 'Program increment';

  static filterType = 'ProgramIncrementFilters!';
  static filters = { projectId: 'ID' };

  static fields = {
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    endDate: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    programIncrementIterationsCount: attr({ readable: true }),
    progress: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    riskFactorsCount: attr({ readable: true }),
    startDate: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    workflowStatus: attr.belongsTo({
      readable: true,
      typename: 'WorkflowStatus',
    }),
    comments: attr.hasMany({ readable: true }),
    programIncrementIterations: attr.hasMany({ readable: true }),
    records: attr.hasMany({
      args: { filters: 'ProgramIncrementRecordFilters' },
      readable: true,
    }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default ProgramIncrement;
